// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PreviewTester/PreviewTester.module.css - Add/update these classes */

/* Single-node transformation CSS classes */
/* PreviewTester/PreviewTester.module.css - Add these styles */

/* PreviewTester/PreviewTester.module.css */

/* PreviewTester/PreviewTester.module.css - Add these styles */

/* PreviewTester.module.css or a global CSS file */

.PreviewTester_preview-image__1-ggV {
  transition: transform 0.2s ease;
  cursor: pointer;
}

.PreviewTester_preview-image__1-ggV:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.PreviewTester_media-wrapper__JQbGI {
  display: inline-block;
  margin: 4px 0;
  border-radius: 8px;
  overflow: hidden;
}

.PreviewTester_rendered-image__W65R6 {
  display: block;
  width: 250px;
  height: 250px;
  object-fit: cover;
}

.PreviewTester_section-header__qNUGj {
  display: block;
  font-weight: 600;
  color: #2d3748;
  margin: 8px 0 4px 0;
  font-size: 14px;
}
.PreviewTester_plain-text__wmFcL {
  display: block;
  color: #4a5568;
  padding: 2px 0;
}
.PreviewTester_highlight__8U8s5 {
  background-color: #fefcbf;
  padding: 2px 4px;
  border-radius: 3px;
}
.PreviewTester_bold__rAFUX {
  font-weight: 700;
}
.PreviewTester_italic__gTbqp {
  font-style: italic;
}
.PreviewTester_underline__3Vm6m {
  text-decoration: underline;
}
.PreviewTester_strikethrough__6CT0q {
  text-decoration: line-through;
}

/* ============================================================ */
/* FIELD WRAPPER - The container for the entire field */
/* ============================================================ */
.PreviewTester_field-wrapper__5krbV {
  display: inline-block;
  transition: all 0.15s ease;
  padding: 0 2px;
  border-radius: 2px;
}

/* Individual parts of the field */
.PreviewTester_field-key__0Z91t {
  display: inline;
  font-weight: 500;
  color: #2d3748;
}

.PreviewTester_field-separator__bzxfm {
  display: inline;
  color: #a0aec0;
  margin: 0 2px;
}

.PreviewTester_field-value__rs4qI {
  display: inline;
}

/* ============================================================ */
/* SINGLE-NODE TRANSFORMATIONS - Applied to the ENTIRE wrapper */
/* ============================================================ */

/* Highlight - applied to the whole field */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5 {
  background-color: #fefcbf !important;
  padding: 0 4px;
  border-radius: 3px;
}

/* Bold - applied to the whole field */
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX {
  font-weight: bold !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
}

/* Italic - applied to the whole field */
.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp {
  font-style: italic !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp .PreviewTester_field-value__rs4qI {
  font-style: italic !important;
}

/* Underline - applied to the whole field */
.PreviewTester_field-wrapper__5krbV.PreviewTester_underline__3Vm6m {
  text-decoration: underline !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_underline__3Vm6m .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_underline__3Vm6m .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_underline__3Vm6m .PreviewTester_field-value__rs4qI {
  text-decoration: underline !important;
}

/* Strikethrough - applied to the whole field */
.PreviewTester_field-wrapper__5krbV.PreviewTester_strikethrough__6CT0q {
  text-decoration: line-through !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_strikethrough__6CT0q .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_strikethrough__6CT0q .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_strikethrough__6CT0q .PreviewTester_field-value__rs4qI {
  text-decoration: line-through !important;
}

/* ============================================================ */
/* COMBINED TRANSFORMATIONS - Applied to the ENTIRE wrapper */
/* ============================================================ */

/* Highlight + Bold */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX {
  background-color: #fefcbf !important;
  font-weight: bold !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
}

/* Highlight + Italic */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp {
  background-color: #fefcbf !important;
  font-style: italic !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp .PreviewTester_field-value__rs4qI {
  font-style: italic !important;
}

/* Highlight + Underline */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m {
  background-color: #fefcbf !important;
  text-decoration: underline !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m .PreviewTester_field-value__rs4qI {
  text-decoration: underline !important;
}

/* Highlight + Strikethrough */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q {
  background-color: #fefcbf !important;
  text-decoration: line-through !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q .PreviewTester_field-value__rs4qI {
  text-decoration: line-through !important;
}

/* Bold + Italic */
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp {
  font-weight: bold !important;
  font-style: italic !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
  font-style: italic !important;
}

/* Bold + Underline */
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m {
  font-weight: bold !important;
  text-decoration: underline !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
  text-decoration: underline !important;
}

/* Italic + Underline */
.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-style: italic !important;
  text-decoration: underline !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m .PreviewTester_field-value__rs4qI {
  font-style: italic !important;
  text-decoration: underline !important;
}

/* Bold + Italic + Underline */
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-weight: bold !important;
  font-style: italic !important;
  text-decoration: underline !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
  font-style: italic !important;
  text-decoration: underline !important;
}

/* Highlight + Bold + Italic */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp {
  background-color: #fefcbf !important;
  font-weight: bold !important;
  font-style: italic !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
  font-style: italic !important;
}

/* Highlight + Bold + Underline */
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m {
  background-color: #fefcbf !important;
  font-weight: bold !important;
  text-decoration: underline !important;
}

.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m .PreviewTester_field-key__0Z91t,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m .PreviewTester_field-separator__bzxfm,
.PreviewTester_field-wrapper__5krbV.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m .PreviewTester_field-value__rs4qI {
  font-weight: bold !important;
  text-decoration: underline !important;
}

/* ============================================================ */
/* TABLE, CARD, LIST - Multi-node transformations */
/* ============================================================ */

.PreviewTester_previewTable__smDBE {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  font-size: 13px;
}

.PreviewTester_previewTable__smDBE th {
  background-color: #f0f0f0;
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #ddd;
  font-weight: 600;
}

.PreviewTester_previewTable__smDBE td {
  padding: 8px 12px;
  border: 1px solid #ddd;
}

.PreviewTester_previewTable__smDBE tr:nth-child(even) {
  background-color: #fafafa;
}

.PreviewTester_previewTable__smDBE tr:hover {
  background-color: #f0f4ff;
}

.PreviewTester_previewCard__KJMrg {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  background: #fafafa;
  margin-bottom: 12px;
  transition: box-shadow 0.2s;
}

.PreviewTester_previewCard__KJMrg:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.PreviewTester_previewCardTitle__EhX5i {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #2d3748;
}

.PreviewTester_previewList__CX3Wd {
  list-style: none;
  padding: 0;
  margin: 0;
}

.PreviewTester_previewListItem__0Yh3T {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
}

.PreviewTester_previewListItem__0Yh3T:last-child {
  border-bottom: none;
}

.PreviewTester_previewListItem__0Yh3T:hover {
  background-color: #f7fafc;
}

/* Field wrapper - wraps the entire field */
.PreviewTester_field-wrapper__5krbV {
  display: inline-block;
  /* Inherit parent styling */
}

/* Field key - the field name (e.g., "id") */
.PreviewTester_field-key__0Z91t {
  display: inline;
  font-weight: normal;
}

/* Field separator - the separator (e.g., " - ") */
.PreviewTester_field-separator__bzxfm {
  display: inline;
  color: #718096;
}

/* Field value - the field value (e.g., "13") */
.PreviewTester_field-value__rs4qI {
  display: inline;
}

/* Single-node transformation CSS classes */
.PreviewTester_bold__rAFUX {
  font-weight: bold !important;
}

.PreviewTester_italic__gTbqp {
  font-style: italic !important;
}

.PreviewTester_underline__3Vm6m {
  text-decoration: underline !important;
}

.PreviewTester_highlight__8U8s5 {
  background-color: #fefcbf !important; /* light yellow */
}

.PreviewTester_strikethrough__6CT0q {
  text-decoration: line-through !important;
}

/* Combined classes for multiple transformations */
.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp {
  font-weight: bold;
  font-style: italic;
}

.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m {
  font-weight: bold;
  text-decoration: underline;
}

.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-style: italic;
  text-decoration: underline;
}

.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-weight: bold;
  font-style: italic;
  text-decoration: underline;
}

.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX {
  background-color: #fefcbf;
  font-weight: bold;
}

.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp {
  background-color: #fefcbf;
  font-style: italic;
}

.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m {
  background-color: #fefcbf;
  text-decoration: underline;
}

.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q {
  background-color: #fefcbf;
  text-decoration: line-through;
}

/* Field value spans - ensure they display inline */
.PreviewTester_field-value__rs4qI {
  display: inline;
  /* Inherit parent styling */
}

/* Single-node transformation CSS classes */
.PreviewTester_bold__rAFUX {
  font-weight: bold !important;
}

.PreviewTester_italic__gTbqp {
  font-style: italic !important;
}

.PreviewTester_underline__3Vm6m {
  text-decoration: underline !important;
}

.PreviewTester_highlight__8U8s5 {
  background-color: #fefcbf !important; /* light yellow */
}

.PreviewTester_strikethrough__6CT0q {
  text-decoration: line-through !important;
}

/* Combined classes for multiple transformations */
.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp {
  font-weight: bold;
  font-style: italic;
}

.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m {
  font-weight: bold;
  text-decoration: underline;
}

.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-style: italic;
  text-decoration: underline;
}

.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-weight: bold;
  font-style: italic;
  text-decoration: underline;
}

/* Highlight with other styles - preserve highlight visibility */
.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX {
  background-color: #fefcbf;
  font-weight: bold;
}

.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp {
  background-color: #fefcbf;
  font-style: italic;
}

.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m {
  background-color: #fefcbf;
  text-decoration: underline;
}

.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q {
  background-color: #fefcbf;
  text-decoration: line-through;
}

/* PreviewTester/PreviewTester.module.css */

/* Field wrapper - wraps the entire field (key - value) */
.PreviewTester_field-wrapper__5krbV {
  display: inline-block;
  /* Inherit parent styling */
}

/* Field value spans - for the value part when nested */
.PreviewTester_field-value__rs4qI {
  display: inline;
  /* Inherit parent styling */
}

/* Single-node transformation CSS classes */
.PreviewTester_bold__rAFUX {
  font-weight: bold !important;
}

.PreviewTester_italic__gTbqp {
  font-style: italic !important;
}

.PreviewTester_underline__3Vm6m {
  text-decoration: underline !important;
}

.PreviewTester_highlight__8U8s5 {
  background-color: #fefcbf !important; /* light yellow */
}

.PreviewTester_strikethrough__6CT0q {
  text-decoration: line-through !important;
}

/* Combined classes for multiple transformations */
.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp {
  font-weight: bold;
  font-style: italic;
}

.PreviewTester_bold__rAFUX.PreviewTester_underline__3Vm6m {
  font-weight: bold;
  text-decoration: underline;
}

.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-style: italic;
  text-decoration: underline;
}

.PreviewTester_bold__rAFUX.PreviewTester_italic__gTbqp.PreviewTester_underline__3Vm6m {
  font-weight: bold;
  font-style: italic;
  text-decoration: underline;
}

.PreviewTester_highlight__8U8s5.PreviewTester_bold__rAFUX {
  background-color: #fefcbf;
  font-weight: bold;
}

.PreviewTester_highlight__8U8s5.PreviewTester_italic__gTbqp {
  background-color: #fefcbf;
  font-style: italic;
}

.PreviewTester_highlight__8U8s5.PreviewTester_underline__3Vm6m {
  background-color: #fefcbf;
  text-decoration: underline;
}

.PreviewTester_highlight__8U8s5.PreviewTester_strikethrough__6CT0q {
  background-color: #fefcbf;
  text-decoration: line-through;
}

.PreviewTester_container__oEh1E {
  padding: 20px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.PreviewTester_title__rhVxs {
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 20px;
}

/* ✅ Flex row: left and right panels push each other */
.PreviewTester_mainLayout__0rLTn {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-height: 0;
}

/* ✅ When expanded: left panel takes a stable width */
.PreviewTester_leftPanelWrapper__lLrV2 {
  flex: 0 0 420px; /* adjust to taste */
  max-width: 420px;
  min-width: 0;
  display: flex;
  transition:
    flex-basis 0.25s ease,
    max-width 0.25s ease;
}

.PreviewTester_leftPanelWrapperExpanded__Pawub {
  width: 720px;   /* ← pick the width you want */
  flex-shrink: 0;
  transition: width 0.25s ease;
}
.PreviewTester_leftPanelWrapper__lLrV2,
.PreviewTester_leftPanelWrapperExpanded__Pawub {
  transition: width 0.25s ease;
}
/* ✅ When collapsed: left panel shrinks to the 40px rail */
.PreviewTester_collapsedWrapper__CNA-I {
  flex: 0 0 40px;
  max-width: 40px;
  min-width: 40px;
  display: flex;
  transition:
    flex-basis 0.25s ease,
    max-width 0.25s ease;
}

/* Right panel always takes the remaining space */
.PreviewTester_mainLayout__0rLTn > :last-child {
  flex: 1 1 auto;
  min-width: 0;
}

/* Scenario branch styles */
.PreviewTester_scenario-branch__5zg0M {
  transition: all 0.2s ease;
}

.PreviewTester_scenario-branch__5zg0M.PreviewTester_active-path__ENjAN {
  opacity: 1 !important;
  border-color: #4299e1 !important;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.3);
}

.PreviewTester_scenario-branch__5zg0M.PreviewTester_inactive-path__J262P {
  opacity: 0.7;
}

.PreviewTester_scenario-branch__5zg0M.PreviewTester_level-0__6cBQm.PreviewTester_active-path__ENjAN {
  background-color: #ebf8ff;
}

.PreviewTester_scenario-branch__5zg0M.PreviewTester_level-1__GfVJ5.PreviewTester_active-path__ENjAN {
  background-color: #e6fffa;
}

.PreviewTester_scenario-branch__5zg0M.PreviewTester_level-2__vlIxQ.PreviewTester_active-path__ENjAN {
  background-color: #f0fff4;
}

.PreviewTester_scenario-branch__5zg0M.PreviewTester_level-3__8Sh9E.PreviewTester_active-path__ENjAN {
  background-color: #faf5ff;
}

/* Button styles */
.PreviewTester_scenario-button__gXHZc {
  padding: 4px 12px;
  background-color: white;
  border: 1px solid #bee3f8;
  border-radius: 4px;
  font-size: 11px;
  color: #2b6cb0;
  transition: all 0.2s;
  white-space: nowrap;

  user-select: text;
  -webkit-user-select: text;
}
.PreviewTester_scenario-button__gXHZc:hover {
  background-color: #bee3f8;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.PreviewTester_scenario-button__gXHZc.PreviewTester_active-button__aF616 {
  background-color: #4299e1;
  color: white;
  border-color: #4299e1;
}

.PreviewTester_scenario-button__gXHZc.PreviewTester_else-button__Dfrev {
  border-color: #f6ad55;
  background-color: #fefcbf;
  color: #744210;
}

.PreviewTester_scenario-button__gXHZc.PreviewTester_else-button__Dfrev:hover {
  background-color: #f6ad55;
}

/* Active path indicator */
.PreviewTester_active-path-badge__d7E2n {
  display: inline-block;
  padding: 2px 8px;
  background-color: #4299e1;
  color: white;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 500;
  margin-left: 8px;
}

/* Level specific styles */
.PreviewTester_level-0__6cBQm.PreviewTester_active-path__ENjAN {
  border-left: 3px solid #4299e1;
}

.PreviewTester_level-1__GfVJ5.PreviewTester_active-path__ENjAN {
  border-left: 3px solid #38a169;
}

.PreviewTester_level-2__vlIxQ.PreviewTester_active-path__ENjAN {
  border-left: 3px solid #d69e2e;
}

.PreviewTester_level-3__8Sh9E.PreviewTester_active-path__ENjAN {
  border-left: 3px solid #9f7aea;
}

.PreviewTester_highlight__8U8s5 {
  background-color: yellow;
}

.PreviewTester_horizontals__XYyI1 {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 14px;
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
  overflow-y: hidden;
  height: 90%;
}

.PreviewTester_horizontals__XYyI1 .PreviewTester_item-ui-screen__c7o7g {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 10px);
  max-width: calc(33.333% - 10px);
  min-width: 250px;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .PreviewTester_horizontals__XYyI1 .PreviewTester_item-ui-screen__c7o7g {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 7px);
    max-width: calc(50% - 7px);
  }
}

@media (max-width: 600px) {
  .PreviewTester_horizontals__XYyI1 .PreviewTester_item-ui-screen__c7o7g {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 0;
  }
}

.PreviewTester_verticals__Fz9dP {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
}

.PreviewTester_verticals__Fz9dP .PreviewTester_item-ui-screen__c7o7g {
  width: 100%;
  flex: 0 0 auto;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewTester/PreviewTester.module.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,2CAA2C;AAC3C,8DAA8D;;AAE9D,2CAA2C;;AAE3C,8DAA8D;;AAE9D,kDAAkD;;AAElD;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;;AAEA,iEAAiE;AACjE,uDAAuD;AACvD,iEAAiE;AACjE;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,iEAAiE;AACjE,gEAAgE;AAChE,iEAAiE;;AAEjE,2CAA2C;AAC3C;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA,iEAAiE;AACjE,6DAA6D;AAC7D,iEAAiE;;AAEjE,qBAAqB;AACrB;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;;;EAGE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;;EAGE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;;EAGE,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;;;EAGE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA,iEAAiE;AACjE,mDAAmD;AACnD,iEAAiE;;AAEjE;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,2CAA2C;;AAE3C,yDAAyD;AACzD;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb;;qBAEmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,eAAe,EAAE,oBAAoB;EACrC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb;;wBAEsB;AACxB;;AAEA;EACE,YAAY,IAAI,8BAA8B;EAC9C,cAAc;EACd,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;AAC9B;AACA,0DAA0D;AAC1D;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb;;wBAEsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;;EAEnB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB","sourcesContent":["/* PreviewTester/PreviewTester.module.css - Add/update these classes */\n\n/* Single-node transformation CSS classes */\n/* PreviewTester/PreviewTester.module.css - Add these styles */\n\n/* PreviewTester/PreviewTester.module.css */\n\n/* PreviewTester/PreviewTester.module.css - Add these styles */\n\n/* PreviewTester.module.css or a global CSS file */\n\n.preview-image {\n  transition: transform 0.2s ease;\n  cursor: pointer;\n}\n\n.preview-image:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.media-wrapper {\n  display: inline-block;\n  margin: 4px 0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.rendered-image {\n  display: block;\n  width: 250px;\n  height: 250px;\n  object-fit: cover;\n}\n\n.section-header {\n  display: block;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 8px 0 4px 0;\n  font-size: 14px;\n}\n.plain-text {\n  display: block;\n  color: #4a5568;\n  padding: 2px 0;\n}\n.highlight {\n  background-color: #fefcbf;\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n.bold {\n  font-weight: 700;\n}\n.italic {\n  font-style: italic;\n}\n.underline {\n  text-decoration: underline;\n}\n.strikethrough {\n  text-decoration: line-through;\n}\n\n/* ============================================================ */\n/* FIELD WRAPPER - The container for the entire field */\n/* ============================================================ */\n.field-wrapper {\n  display: inline-block;\n  transition: all 0.15s ease;\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n/* Individual parts of the field */\n.field-key {\n  display: inline;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.field-separator {\n  display: inline;\n  color: #a0aec0;\n  margin: 0 2px;\n}\n\n.field-value {\n  display: inline;\n}\n\n/* ============================================================ */\n/* SINGLE-NODE TRANSFORMATIONS - Applied to the ENTIRE wrapper */\n/* ============================================================ */\n\n/* Highlight - applied to the whole field */\n.field-wrapper.highlight {\n  background-color: #fefcbf !important;\n  padding: 0 4px;\n  border-radius: 3px;\n}\n\n/* Bold - applied to the whole field */\n.field-wrapper.bold {\n  font-weight: bold !important;\n}\n\n.field-wrapper.bold .field-key,\n.field-wrapper.bold .field-separator,\n.field-wrapper.bold .field-value {\n  font-weight: bold !important;\n}\n\n/* Italic - applied to the whole field */\n.field-wrapper.italic {\n  font-style: italic !important;\n}\n\n.field-wrapper.italic .field-key,\n.field-wrapper.italic .field-separator,\n.field-wrapper.italic .field-value {\n  font-style: italic !important;\n}\n\n/* Underline - applied to the whole field */\n.field-wrapper.underline {\n  text-decoration: underline !important;\n}\n\n.field-wrapper.underline .field-key,\n.field-wrapper.underline .field-separator,\n.field-wrapper.underline .field-value {\n  text-decoration: underline !important;\n}\n\n/* Strikethrough - applied to the whole field */\n.field-wrapper.strikethrough {\n  text-decoration: line-through !important;\n}\n\n.field-wrapper.strikethrough .field-key,\n.field-wrapper.strikethrough .field-separator,\n.field-wrapper.strikethrough .field-value {\n  text-decoration: line-through !important;\n}\n\n/* ============================================================ */\n/* COMBINED TRANSFORMATIONS - Applied to the ENTIRE wrapper */\n/* ============================================================ */\n\n/* Highlight + Bold */\n.field-wrapper.highlight.bold {\n  background-color: #fefcbf !important;\n  font-weight: bold !important;\n}\n\n.field-wrapper.highlight.bold .field-key,\n.field-wrapper.highlight.bold .field-separator,\n.field-wrapper.highlight.bold .field-value {\n  font-weight: bold !important;\n}\n\n/* Highlight + Italic */\n.field-wrapper.highlight.italic {\n  background-color: #fefcbf !important;\n  font-style: italic !important;\n}\n\n.field-wrapper.highlight.italic .field-key,\n.field-wrapper.highlight.italic .field-separator,\n.field-wrapper.highlight.italic .field-value {\n  font-style: italic !important;\n}\n\n/* Highlight + Underline */\n.field-wrapper.highlight.underline {\n  background-color: #fefcbf !important;\n  text-decoration: underline !important;\n}\n\n.field-wrapper.highlight.underline .field-key,\n.field-wrapper.highlight.underline .field-separator,\n.field-wrapper.highlight.underline .field-value {\n  text-decoration: underline !important;\n}\n\n/* Highlight + Strikethrough */\n.field-wrapper.highlight.strikethrough {\n  background-color: #fefcbf !important;\n  text-decoration: line-through !important;\n}\n\n.field-wrapper.highlight.strikethrough .field-key,\n.field-wrapper.highlight.strikethrough .field-separator,\n.field-wrapper.highlight.strikethrough .field-value {\n  text-decoration: line-through !important;\n}\n\n/* Bold + Italic */\n.field-wrapper.bold.italic {\n  font-weight: bold !important;\n  font-style: italic !important;\n}\n\n.field-wrapper.bold.italic .field-key,\n.field-wrapper.bold.italic .field-separator,\n.field-wrapper.bold.italic .field-value {\n  font-weight: bold !important;\n  font-style: italic !important;\n}\n\n/* Bold + Underline */\n.field-wrapper.bold.underline {\n  font-weight: bold !important;\n  text-decoration: underline !important;\n}\n\n.field-wrapper.bold.underline .field-key,\n.field-wrapper.bold.underline .field-separator,\n.field-wrapper.bold.underline .field-value {\n  font-weight: bold !important;\n  text-decoration: underline !important;\n}\n\n/* Italic + Underline */\n.field-wrapper.italic.underline {\n  font-style: italic !important;\n  text-decoration: underline !important;\n}\n\n.field-wrapper.italic.underline .field-key,\n.field-wrapper.italic.underline .field-separator,\n.field-wrapper.italic.underline .field-value {\n  font-style: italic !important;\n  text-decoration: underline !important;\n}\n\n/* Bold + Italic + Underline */\n.field-wrapper.bold.italic.underline {\n  font-weight: bold !important;\n  font-style: italic !important;\n  text-decoration: underline !important;\n}\n\n.field-wrapper.bold.italic.underline .field-key,\n.field-wrapper.bold.italic.underline .field-separator,\n.field-wrapper.bold.italic.underline .field-value {\n  font-weight: bold !important;\n  font-style: italic !important;\n  text-decoration: underline !important;\n}\n\n/* Highlight + Bold + Italic */\n.field-wrapper.highlight.bold.italic {\n  background-color: #fefcbf !important;\n  font-weight: bold !important;\n  font-style: italic !important;\n}\n\n.field-wrapper.highlight.bold.italic .field-key,\n.field-wrapper.highlight.bold.italic .field-separator,\n.field-wrapper.highlight.bold.italic .field-value {\n  font-weight: bold !important;\n  font-style: italic !important;\n}\n\n/* Highlight + Bold + Underline */\n.field-wrapper.highlight.bold.underline {\n  background-color: #fefcbf !important;\n  font-weight: bold !important;\n  text-decoration: underline !important;\n}\n\n.field-wrapper.highlight.bold.underline .field-key,\n.field-wrapper.highlight.bold.underline .field-separator,\n.field-wrapper.highlight.bold.underline .field-value {\n  font-weight: bold !important;\n  text-decoration: underline !important;\n}\n\n/* ============================================================ */\n/* TABLE, CARD, LIST - Multi-node transformations */\n/* ============================================================ */\n\n.previewTable {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 8px 0;\n  font-size: 13px;\n}\n\n.previewTable th {\n  background-color: #f0f0f0;\n  padding: 8px 12px;\n  text-align: left;\n  border: 1px solid #ddd;\n  font-weight: 600;\n}\n\n.previewTable td {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n}\n\n.previewTable tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.previewTable tr:hover {\n  background-color: #f0f4ff;\n}\n\n.previewCard {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  background: #fafafa;\n  margin-bottom: 12px;\n  transition: box-shadow 0.2s;\n}\n\n.previewCard:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.previewCardTitle {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.previewList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.previewListItem {\n  padding: 8px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 13px;\n}\n\n.previewListItem:last-child {\n  border-bottom: none;\n}\n\n.previewListItem:hover {\n  background-color: #f7fafc;\n}\n\n/* Field wrapper - wraps the entire field */\n.field-wrapper {\n  display: inline-block;\n  /* Inherit parent styling */\n}\n\n/* Field key - the field name (e.g., \"id\") */\n.field-key {\n  display: inline;\n  font-weight: normal;\n}\n\n/* Field separator - the separator (e.g., \" - \") */\n.field-separator {\n  display: inline;\n  color: #718096;\n}\n\n/* Field value - the field value (e.g., \"13\") */\n.field-value {\n  display: inline;\n}\n\n/* Single-node transformation CSS classes */\n.bold {\n  font-weight: bold !important;\n}\n\n.italic {\n  font-style: italic !important;\n}\n\n.underline {\n  text-decoration: underline !important;\n}\n\n.highlight {\n  background-color: #fefcbf !important; /* light yellow */\n}\n\n.strikethrough {\n  text-decoration: line-through !important;\n}\n\n/* Combined classes for multiple transformations */\n.bold.italic {\n  font-weight: bold;\n  font-style: italic;\n}\n\n.bold.underline {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.italic.underline {\n  font-style: italic;\n  text-decoration: underline;\n}\n\n.bold.italic.underline {\n  font-weight: bold;\n  font-style: italic;\n  text-decoration: underline;\n}\n\n.highlight.bold {\n  background-color: #fefcbf;\n  font-weight: bold;\n}\n\n.highlight.italic {\n  background-color: #fefcbf;\n  font-style: italic;\n}\n\n.highlight.underline {\n  background-color: #fefcbf;\n  text-decoration: underline;\n}\n\n.highlight.strikethrough {\n  background-color: #fefcbf;\n  text-decoration: line-through;\n}\n\n/* Field value spans - ensure they display inline */\n.field-value {\n  display: inline;\n  /* Inherit parent styling */\n}\n\n/* Single-node transformation CSS classes */\n.bold {\n  font-weight: bold !important;\n}\n\n.italic {\n  font-style: italic !important;\n}\n\n.underline {\n  text-decoration: underline !important;\n}\n\n.highlight {\n  background-color: #fefcbf !important; /* light yellow */\n}\n\n.strikethrough {\n  text-decoration: line-through !important;\n}\n\n/* Combined classes for multiple transformations */\n.bold.italic {\n  font-weight: bold;\n  font-style: italic;\n}\n\n.bold.underline {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.italic.underline {\n  font-style: italic;\n  text-decoration: underline;\n}\n\n.bold.italic.underline {\n  font-weight: bold;\n  font-style: italic;\n  text-decoration: underline;\n}\n\n/* Highlight with other styles - preserve highlight visibility */\n.highlight.bold {\n  background-color: #fefcbf;\n  font-weight: bold;\n}\n\n.highlight.italic {\n  background-color: #fefcbf;\n  font-style: italic;\n}\n\n.highlight.underline {\n  background-color: #fefcbf;\n  text-decoration: underline;\n}\n\n.highlight.strikethrough {\n  background-color: #fefcbf;\n  text-decoration: line-through;\n}\n\n/* PreviewTester/PreviewTester.module.css */\n\n/* Field wrapper - wraps the entire field (key - value) */\n.field-wrapper {\n  display: inline-block;\n  /* Inherit parent styling */\n}\n\n/* Field value spans - for the value part when nested */\n.field-value {\n  display: inline;\n  /* Inherit parent styling */\n}\n\n/* Single-node transformation CSS classes */\n.bold {\n  font-weight: bold !important;\n}\n\n.italic {\n  font-style: italic !important;\n}\n\n.underline {\n  text-decoration: underline !important;\n}\n\n.highlight {\n  background-color: #fefcbf !important; /* light yellow */\n}\n\n.strikethrough {\n  text-decoration: line-through !important;\n}\n\n/* Combined classes for multiple transformations */\n.bold.italic {\n  font-weight: bold;\n  font-style: italic;\n}\n\n.bold.underline {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.italic.underline {\n  font-style: italic;\n  text-decoration: underline;\n}\n\n.bold.italic.underline {\n  font-weight: bold;\n  font-style: italic;\n  text-decoration: underline;\n}\n\n.highlight.bold {\n  background-color: #fefcbf;\n  font-weight: bold;\n}\n\n.highlight.italic {\n  background-color: #fefcbf;\n  font-style: italic;\n}\n\n.highlight.underline {\n  background-color: #fefcbf;\n  text-decoration: underline;\n}\n\n.highlight.strikethrough {\n  background-color: #fefcbf;\n  text-decoration: line-through;\n}\n\n.container {\n  padding: 20px;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n    Arial, sans-serif;\n  background-color: #f5f7fa;\n  min-height: 100vh;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 20px;\n}\n\n/* ✅ Flex row: left and right panels push each other */\n.mainLayout {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n/* ✅ When expanded: left panel takes a stable width */\n.leftPanelWrapper {\n  flex: 0 0 420px; /* adjust to taste */\n  max-width: 420px;\n  min-width: 0;\n  display: flex;\n  transition:\n    flex-basis 0.25s ease,\n    max-width 0.25s ease;\n}\n\n.leftPanelWrapperExpanded {\n  width: 720px;   /* ← pick the width you want */\n  flex-shrink: 0;\n  transition: width 0.25s ease;\n}\n.leftPanelWrapper,\n.leftPanelWrapperExpanded {\n  transition: width 0.25s ease;\n}\n/* ✅ When collapsed: left panel shrinks to the 40px rail */\n.collapsedWrapper {\n  flex: 0 0 40px;\n  max-width: 40px;\n  min-width: 40px;\n  display: flex;\n  transition:\n    flex-basis 0.25s ease,\n    max-width 0.25s ease;\n}\n\n/* Right panel always takes the remaining space */\n.mainLayout > :last-child {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n/* Scenario branch styles */\n.scenario-branch {\n  transition: all 0.2s ease;\n}\n\n.scenario-branch.active-path {\n  opacity: 1 !important;\n  border-color: #4299e1 !important;\n  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.3);\n}\n\n.scenario-branch.inactive-path {\n  opacity: 0.7;\n}\n\n.scenario-branch.level-0.active-path {\n  background-color: #ebf8ff;\n}\n\n.scenario-branch.level-1.active-path {\n  background-color: #e6fffa;\n}\n\n.scenario-branch.level-2.active-path {\n  background-color: #f0fff4;\n}\n\n.scenario-branch.level-3.active-path {\n  background-color: #faf5ff;\n}\n\n/* Button styles */\n.scenario-button {\n  padding: 4px 12px;\n  background-color: white;\n  border: 1px solid #bee3f8;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #2b6cb0;\n  transition: all 0.2s;\n  white-space: nowrap;\n\n  user-select: text;\n  -webkit-user-select: text;\n}\n.scenario-button:hover {\n  background-color: #bee3f8;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.scenario-button.active-button {\n  background-color: #4299e1;\n  color: white;\n  border-color: #4299e1;\n}\n\n.scenario-button.else-button {\n  border-color: #f6ad55;\n  background-color: #fefcbf;\n  color: #744210;\n}\n\n.scenario-button.else-button:hover {\n  background-color: #f6ad55;\n}\n\n/* Active path indicator */\n.active-path-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  background-color: #4299e1;\n  color: white;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 500;\n  margin-left: 8px;\n}\n\n/* Level specific styles */\n.level-0.active-path {\n  border-left: 3px solid #4299e1;\n}\n\n.level-1.active-path {\n  border-left: 3px solid #38a169;\n}\n\n.level-2.active-path {\n  border-left: 3px solid #d69e2e;\n}\n\n.level-3.active-path {\n  border-left: 3px solid #9f7aea;\n}\n\n.highlight {\n  background-color: yellow;\n}\n\n.horizontals {\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  gap: 14px;\n  width: 100%;\n  padding: 4px;\n  box-sizing: border-box;\n  overflow-y: hidden;\n  height: 90%;\n}\n\n.horizontals .item-ui-screen {\n  flex: 0 0 calc(33.333% - 10px);\n  max-width: calc(33.333% - 10px);\n  min-width: 250px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 900px) {\n  .horizontals .item-ui-screen {\n    flex: 0 0 calc(50% - 7px);\n    max-width: calc(50% - 7px);\n  }\n}\n\n@media (max-width: 600px) {\n  .horizontals .item-ui-screen {\n    flex: 0 0 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n}\n\n.verticals {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n.verticals .item-ui-screen {\n  width: 100%;\n  flex: 0 0 auto;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview-image": `PreviewTester_preview-image__1-ggV`,
	"media-wrapper": `PreviewTester_media-wrapper__JQbGI`,
	"rendered-image": `PreviewTester_rendered-image__W65R6`,
	"section-header": `PreviewTester_section-header__qNUGj`,
	"plain-text": `PreviewTester_plain-text__wmFcL`,
	"highlight": `PreviewTester_highlight__8U8s5`,
	"bold": `PreviewTester_bold__rAFUX`,
	"italic": `PreviewTester_italic__gTbqp`,
	"underline": `PreviewTester_underline__3Vm6m`,
	"strikethrough": `PreviewTester_strikethrough__6CT0q`,
	"field-wrapper": `PreviewTester_field-wrapper__5krbV`,
	"field-key": `PreviewTester_field-key__0Z91t`,
	"field-separator": `PreviewTester_field-separator__bzxfm`,
	"field-value": `PreviewTester_field-value__rs4qI`,
	"previewTable": `PreviewTester_previewTable__smDBE`,
	"previewCard": `PreviewTester_previewCard__KJMrg`,
	"previewCardTitle": `PreviewTester_previewCardTitle__EhX5i`,
	"previewList": `PreviewTester_previewList__CX3Wd`,
	"previewListItem": `PreviewTester_previewListItem__0Yh3T`,
	"container": `PreviewTester_container__oEh1E`,
	"title": `PreviewTester_title__rhVxs`,
	"mainLayout": `PreviewTester_mainLayout__0rLTn`,
	"leftPanelWrapper": `PreviewTester_leftPanelWrapper__lLrV2`,
	"leftPanelWrapperExpanded": `PreviewTester_leftPanelWrapperExpanded__Pawub`,
	"collapsedWrapper": `PreviewTester_collapsedWrapper__CNA-I`,
	"scenario-branch": `PreviewTester_scenario-branch__5zg0M`,
	"active-path": `PreviewTester_active-path__ENjAN`,
	"inactive-path": `PreviewTester_inactive-path__J262P`,
	"level-0": `PreviewTester_level-0__6cBQm`,
	"level-1": `PreviewTester_level-1__GfVJ5`,
	"level-2": `PreviewTester_level-2__vlIxQ`,
	"level-3": `PreviewTester_level-3__8Sh9E`,
	"scenario-button": `PreviewTester_scenario-button__gXHZc`,
	"active-button": `PreviewTester_active-button__aF616`,
	"else-button": `PreviewTester_else-button__Dfrev`,
	"active-path-badge": `PreviewTester_active-path-badge__d7E2n`,
	"horizontals": `PreviewTester_horizontals__XYyI1`,
	"item-ui-screen": `PreviewTester_item-ui-screen__c7o7g`,
	"verticals": `PreviewTester_verticals__Fz9dP`
};
export default ___CSS_LOADER_EXPORT___;
